import { useState } from "react";
import dynamic from "next/dynamic";

import { ContactsContext } from "~/contexts/ContactsContext";

const ContactDrawer = dynamic(() =>
  // biome-ignore lint/plugin/no-async-import: defer ContactDrawer (google-libphonenumber, task drawers) from _app chunk
  import("~/components/person/contact-drawer/ContactDrawer").then((m) => m.ContactDrawer),
);

export const ContactDrawerWrapper = ({ children }: { children: React.ReactNode }) => {
  const [contactViewingId, setContactViewingId] = useState<string | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <ContactsContext.Provider value={{ setContactViewingId, setIsEditing }}>
      {children}
      {contactViewingId ? <ContactDrawer contactViewingId={contactViewingId} isEditing={isEditing} /> : null}
    </ContactsContext.Provider>
  );
};
